var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_5a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#75777B",
    d: "m2.5 8 4-6.5 6 3.5c.1667 1.5.5 4.6.5 5s-1 2.8333-1.5 4L7 15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCDDE0",
    d: "M8 0C3.5817 0 0 3.5818 0 8c0 4.4185 3.5817 8 8 8s8-3.5815 8-8c0-4.4182-3.5817-8-8-8m0 4c.5523 0 1 .4478 1 1 0 .5525-.4477 1-1 1s-1-.4475-1-1c0-.5522.4477-1 1-1m1.5 8h-3a.5.5 0 0 1 0-1H7V8h-.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5V11h.5a.5.5 0 0 1 0 1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_5a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info.5a840e66dc4c0646391c1aed5150e804.svg";